import { PaginatedDataDTO } from "@bottega52/commons-pagination";
import { AppBar, Card, IconButton, Tab, Tabs } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { Edit, Visibility } from "@material-ui/icons";
import DomainsIcon from '@material-ui/icons/Domain';
import CustomersIcon from '@material-ui/icons/GroupOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import PersonAddIcon from '@material-ui/icons/PersonAddOutlined';
import * as React from "react";
import { ConnectedProps, connect } from "react-redux";
import { VarOpportunityStatusOptions } from "../../codec/varOpportunityInDTODecoder";
import ReduxLanguage from '../../components/ReduxLanguage';
import { IState } from "../../redux/store";
import { IVarInDTO } from "../../repository/jago/model/input/IVarInDTO";
import { IVarOpportunityInDTO } from "../../repository/jago/model/input/IVarOpportunityInDTO";
import AbilityProvider from "../../services/PermissionService/AbilityProvider";
import { PERMISSIONS } from "../../services/PermissionService/PermissionConstants";
import { GREEN_MAIN } from "../../style/StyleConsts";
import { isDemoCustomer } from "../../utils/Utils";
import FireIconCustom from '../Icons/FireIconCustom';
import Permission from "../Permission/Permission";
import VarCustomersSection from "./VarCustomersSection";
import VarOpportunitiesSection from "./VarOpportunitiesSection";
import VarUsersSection from "./VarUsersSection";

import { ICustomerInDTO } from "../../repository/jago/model/input/ICustomerInDTO";
import { getVarActiveBadges } from "../../utils/Utils";
import VarPartnerLevel from "./VarPartnerLevel";
import { VarCategoryType } from "../../codec/varInDTODecoder";

const styles = createStyles({
  container: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column',
    paddingBottom: 50,
  },
  headerContainer: {
    marginTop: 20,
    padding: 10,
    borderLeft: '3px solid #0D47A1',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    marginRight: 5,
    fontSize: 25,
  },
  title: {
    fontWeight: 'bold'
  },
  cardsContainer: {
    display: 'flex',
    gap: 30,
    padding: '0 20px',
  },
  statCard: {
    flex: 1,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  statTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: '#666',
    marginBottom: 6,
  },
  statNumber: {
    fontSize: 20,
    fontWeight: 'bold',
    color: GREEN_MAIN,
  }
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface IVarDetailsViewProps extends WithStyles<typeof styles>{
  onOpenEditVarForm: () => void;
  onOpenVarDetails: () => void;
  onGoToCustomerDetailsPage?: (customerId: number) => void;
  onOpenVarCertificate: () => void;
}

export interface IVarDetailsViewState {
  activeTab: number;
}

export type ComponentProps = IVarDetailsViewProps & IReduxProps;
class VarDetailsView extends React.Component<ComponentProps, IVarDetailsViewState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      activeTab: 0,
    }
  }

  public onTabChange(index: number) {
    this.setState({ activeTab: index });
  }

  

  public render() {
    const { selectedVar, customers, varUsers, opportunities, classes, onOpenEditVarForm, onOpenVarDetails, onOpenVarCertificate, varBurnRate } = this.props;
    const { activeTab } = this.state;
    const VAR = (selectedVar as IVarInDTO)
    const carReadOpportunities = AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.OPPORTUNITY_READ);
    const activeBadgesIndexes = getVarActiveBadges(VAR);
    
    const runningQuotationsStatuses = [VarOpportunityStatusOptions.DRAFT, VarOpportunityStatusOptions.ON_APPROVAL, VarOpportunityStatusOptions.APPROVED];
    const runningQuotationsCounter = (
      (opportunities as PaginatedDataDTO<IVarOpportunityInDTO>).content || []
    ).filter(opportunity => runningQuotationsStatuses.includes(opportunity.status as VarOpportunityStatusOptions)).length;
    
    const customersData = (customers as PaginatedDataDTO<ICustomerInDTO>).content || [];
    const activeCustomersCounter = customersData
      .filter(customer => !isDemoCustomer(customer.name))
      .length;
    
    const activeSystemsCounter = VAR.plantNumber ?? "-";
    const monthlyCreditsBurnRate = VAR.burnRate ?? "-";

    const isVarDealer = VAR.categoryType === VarCategoryType.DEALER;
    
    return (
      <div className={classes.container}>
        <Card className={classes.headerContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <div className={classes.headerTextContainer}>
                <h2 className={classes.title}>{VAR && VAR.name ? `${VAR.id} - ${VAR.name}` : ''}</h2>
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.VAR_READ}>
                  <IconButton onClick={() => onOpenVarDetails()}>
                    <Visibility style={{ color: '#3f3f3f' }} />
                  </IconButton>
                </Permission>
              </div>
              {VAR.logoFileUrl ? (
                <img src={VAR.logoFileUrl} style={{ height: 'auto', width: 100, marginLeft: 10 }} alt="logo" />
              ) : null}
            </div>
            <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.VAR_UPDATE}>
              <IconButton onClick={() => onOpenEditVarForm()}>
                <Edit style={{ color: '#3f3f3f' }} />
              </IconButton>
            </Permission>
          </div>
        </Card>
        {isVarDealer ? null : (
          <>
          <Card style={{ marginTop: 20 }}>
            <VarPartnerLevel activeBadgesIndexes={activeBadgesIndexes} onOpenVarCertificate={() => onOpenVarCertificate()} />
          </Card>
          <div className={classes.cardsContainer} style={{ marginTop: 20 }}>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.runningQuotations' /></h4>
                <MonetizationOnOutlinedIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5 }} />
              </div>
              <div className={classes.statNumber}>{runningQuotationsCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.activeCustomers' /></h4>
                <CustomersIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5, marginBottom: 1 }} />
              </div>
              <div className={classes.statNumber}>{activeCustomersCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.activeSystems' /></h4>
                <DomainsIcon style={{ fontSize: 22, color: '#3f3f3f', marginLeft: 5, marginBottom: 2 }} />
              </div>
              <div className={classes.statNumber}>{activeSystemsCounter}</div>
            </Card>
            <Card className={classes.statCard}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 className={classes.statTitle} style={{ color: '#3f3f3f' }}><ReduxLanguage languageKey='vars.monthlyCreditsBurnRate' /></h4>
                <FireIconCustom style={{ width: 25, color: '#3f3f3f', marginLeft: 5, marginBottom: 2 }} />
              </div>
              <div className={classes.statNumber}>{monthlyCreditsBurnRate}</div>
            </Card>
          </div>
          </>
        )}
        <AppBar position="sticky" style={{ backgroundColor: 'white', marginTop: 20 }}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            style={{ backgroundColor: 'white', width: '100%' }}
            onChange={(e, index) => this.onTabChange(index)}
          >
            <Tab icon={<CustomersIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="vars.varCustomers" /></h5>} />
            <Tab icon={<PersonAddIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="vars.varUsers" /></h5>} />
            {carReadOpportunities ? <Tab icon={<MonetizationOnOutlinedIcon style={{ fontSize: 25 }} />} label={<h5 style={{ margin: 0 }}><ReduxLanguage languageKey="vars.varOpportunities" /></h5>} /> : null}
          </Tabs>
        </AppBar>
        {activeTab === 0 && 
          <VarCustomersSection
            VAR={VAR}
            customers={customers as PaginatedDataDTO<ICustomerInDTO>}
            onGoToCustomerDetailsPage={customerId => this.props.onGoToCustomerDetailsPage(customerId)}
          />
        }
        {activeTab === 1 && 
          <VarUsersSection
            VAR={VAR}
            varUsers={varUsers}
          />
        }
        {activeTab === 2 && 
          <VarOpportunitiesSection
            VAR={VAR}
            opportunities={(opportunities as PaginatedDataDTO<IVarOpportunityInDTO>)}
          />
        }
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedVar: state.vars.selectedVar.data,
    customers: state.vars.varCustomers.data,
    varUsers: state.vars.users.data,
    opportunities: state.vars.opportunities.data,
    varBurnRate: state.vars.varBurnRate.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles (styles)(VarDetailsView as any));